import React from 'react';

const StatusItem = ({ count, label, className, customStyle }) => {
  const getCountColor = () => {
    if (label === 'Total Indicator of this impact type') return '#000000';
    if (label === 'Total Indicators where data is available') return '#000000';
    return undefined;
  };

  return (
    <div
      className={`indicator-status-item ${className || ''}`}
      style={{ position: 'relative', ...customStyle }}
    >
      <div className="count" style={{ color: getCountColor(), fontWeight: 700 }}>
        {count}
      </div>
      <div className="label" style={{ 
        fontSize: '0.65rem',
        lineHeight: '1.3',
        wordBreak: 'break-word',
        textTransform: (label === 'Total Indicator of this impact type' || label === 'Total Indicators where data is available') ? 'none' : 'uppercase',
        fontWeight: 700,
        color: '#000000'
      }}>
        {label}
      </div>
    </div>
  );
};

const StatusBreakdown = ({ breakdown }) => {
  const {
    totalIndicators,
    indicatorsWithData,
    normalCount,
    warningCount,
    highCount,
    allIndicatorNames = [],
    availableIndicatorNames = [],
    normalIndicators = [],
    warningIndicators = [],
    highIndicators = []
  } = breakdown;

  return (
    <div className="indicator-summary" style={{ marginTop: '0' }}>
      <div className="status-breakdown-container" style={{
        display: 'flex',
        gap: '0',
        alignItems: 'stretch',
        flexWrap: 'wrap'
      }}>
        {/* Indicator Status Group */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.4rem',
          flex: '1 1 0',
          padding: '0.6rem',
          background: 'transparent'
        }}>
          <div style={{
            fontSize: '0.7rem',
            fontWeight: 700,
            color: '#495057',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Indicator Status
          </div>
          <div className="indicator-status-grid-inner" style={{ 
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '0.5rem'
          }}>
            <StatusItem
              count={totalIndicators}
              label="Total Indicator of this impact type"
              customStyle={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                border: '2px solid #d0d0d0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}
            />
            <StatusItem
              count={indicatorsWithData}
              label="Total Indicators where data is available"
              customStyle={{
                background: 'linear-gradient(135deg, #ffffff 0%, #e3f2fd 100%)',
                border: '2px solid #90caf9',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}
            />
          </div>
        </div>

        {/* Vertical Divider Line */}
        <div style={{
          width: '2px',
          backgroundColor: '#adb5bd',
          alignSelf: 'stretch',
          margin: '0.5rem 0.75rem',
          flexShrink: 0
        }} />

        {/* Status Breakdown Group */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.4rem',
          flex: '1 1 0',
          padding: '0.6rem',
          background: 'transparent'
        }}>
          <div style={{
            fontSize: '0.7rem',
            fontWeight: 700,
            color: '#495057',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Status Breakdown
          </div>
          <div style={{ 
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '0.5rem'
          }}>
            <StatusItem
              count={normalCount}
              label="Normal"
              className="normal"
            />
            <StatusItem
              count={warningCount}
              label="Warning"
              className="warning"
            />
            <StatusItem
              count={highCount}
              label="High"
              className="high"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusBreakdown;

